export const generateHash = (): string => (+new Date()).toString(36);
export const generateHash = (): string => (+new Date()).toString(36);
